
export const contentTranslations = {
  'language': {
    ru: 'ru',
    kz: 'kz',
    en: 'en'
  },

  // Hero Section
  'hero.title': {
    ru: 'ГККП "СПОРТИВНЫЙ МЕДИЦИНСКИЙ ЦЕНТР ГОРОДА АСТАНЫ"',
    kz: '"СПОРТТЫҚ МЕДИЦИНА ОРТАЛЫҒЫ" МКҚК',
    en: 'GKSP "SPORTS MEDICAL CENTER OF ASTANA CITY" AKIMAT OF ASTANA CITY'
  },
  'hero.subtitle': {
    ru: 'Профессиональная медицинская помощь спортсменам',
    kz: 'Спортшыларға кәсіби медициналық көмек',
    en: 'Professional medical care for athletes'
  },
  'hero.button': {
    ru: 'Наши услуги',
    kz: 'Біздің қызметтер',
    en: 'Our Services'
  },

  // About Section Short
  'about.title': {
    ru: 'О нашем центре',
    kz: 'Біздің орталық туралы',
    en: 'About Our Center'
  },
  'about.description': {
    ru: 'Спортивный медицинский центр Астаны — ведущее учреждение в области спортивной медицины. Наша миссия — обеспечивать высококачественную медицинскую поддержку для спортсменов всех уровней, используя новейшие технологии и методики лечения.',
    kz: 'Астана қаласының Спорттық медицина орталығы — спорттық медицина саласындағы жетекші мекеме. Біздің миссиямыз — барлық деңгейдегі спортшыларға жаңа технологиялар мен емдеу әдістерін қолдана отырып, жоғары сапалы медициналық қолдау көрсету.',
    en: 'Astana Sports Medical Center is a leading institution in the field of sports medicine. Our mission is to provide high-quality medical support for athletes at all levels, using the latest technologies and treatment methods.'
  },
  'about.more': {
    ru: 'Цель Центра и Миссия Центра',
    kz: 'Орталықтың мақсаты мен миссиясы',
    en: 'Center Goals and Mission'
  },

  // About Full Page
  'about.full.title': {
    ru: 'О нашем центре',
    kz: 'Біздің орталық туралы',
    en: 'About Our Center'
  },
  'about.full.history': {
    ru: 'История центра',
    kz: 'Орталықтың тарихы',
    en: 'Center History'
  },
  'about.full.history.text': {
    ru: 'Спортивный медицинский центр Казахстана был основан в 2005 году с целью обеспечения здоровья профессиональных и любительских спортсменов. За годы работы центр стал лидером в области диагностики, профилактики и реабилитации.',
    kz: 'Қазақстан спорт медицина орталығы 2005 жылы кәсіпқой және әуесқой спортшылардың денсаулығын қорғау мақсатында құрылды. Орталық жылдар бойы диагностика, алдын алу және оңалту саласында көшбасшы болды.',
    en: 'Kazakhstan Sports Medical Center was founded in 2005 with the goal of ensuring the health of professional and amateur athletes. Over the years, the center has become a leader in diagnostics, prevention and rehabilitation.'
  }
};
